import { render, staticRenderFns } from "./ReportCardBasicData.vue?vue&type=template&id=263d1a30&scoped=true&"
import script from "./ReportCardBasicData.vue?vue&type=script&lang=ts&"
export * from "./ReportCardBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d1a30",
  null
  
)

export default component.exports